import ElevateAppBar from "../Components/Header";
import Image from "../image/imprint-image.svg"

const Imprint = () => {
    return ( 
        <div>
    <ElevateAppBar></ElevateAppBar>        
            <div className='imprint-heading'>
                <img src={Image}/>
                <h1>Impressum / Imprint</h1>
                
            <div className='imprint-heading-content'>
            

            <h2>Angaben gem&auml;&szlig; &sect; 5 TMG / Disclosures according to  &sect; 5 TMG</h2>
            <p>Robin Atalan<br />
            L&uuml;beckerstra&szlig;e 15<br />
            30823 Garbsen</p>

            <h2>Kontakt/Contact</h2>
            <p>Telefon: 015118963804<br />
            E-Mail: atalanrobin@gmail.com</p>

            <h2>Redaktionell verantwortlich / Editorially responsible</h2>
            <p>Robin Atalan</p>

            <h2>Haftung für Links / Liability for links</h2>
            <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
            <p>Our offer contains links to external websites of third parties, on whose contents we have no influence. Therefore, we cannot assume any liability for these external contents. The respective provider or operator of the pages is always responsible for the content of the linked pages. The linked pages were checked for possible legal violations at the time of linking. Illegal contents were not recognizable at the time of linking.
            However, a permanent control of the contents of the linked pages is not reasonable without concrete evidence of a violation of the law. If we become aware of any infringements, we will remove such links immediately.</p>
            </div>
            </div>
            
        </div>
     );
}
 
export default Imprint;